export default "__VITE_ASSET__b84d62a9__"